/*
 * Alphabetical mega menu index — header "Alphabetical mega menu" block.
 *
 * Scope is deliberately tiny: it only scrolls the already open panel to a letter
 * group and keeps the active letter in sync. Opening, closing, hover, focus and
 * escape stay with the theme's own HoverDisclosure / HeaderMobileSliderule
 * components, this file never touches them.
 *
 * Multiple instances are supported (one custom element per dropdown, desktop and
 * mobile), listeners are removed in disconnectedCallback so a section reload in
 * the theme editor cannot bind twice, and nothing is added to the global scope.
 */
(function () {
  var SELECTORS = {
    button: '[data-ld-letter]',
    group: '[data-ld-group]',
    scroller: '[data-ld-scroll], [data-drawer-scrolls]',
    panel: '.header__dropdown, .sliderule__panel',
  };
  var ACTIVE = 'is-active';
  var ALL = 'all';

  class Directory extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.buttons = Array.prototype.slice.call(this.querySelectorAll(SELECTORS.button));
      this.groups = Array.prototype.slice.call(this.querySelectorAll(SELECTORS.group));
      this.scroller = this.closest(SELECTORS.scroller);
      this.panel = this.closest(SELECTORS.panel);

      if (!this.buttons.length || !this.groups.length || !this.scroller) return;

      this.addEventListener('click', this.onClick);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.onScroll);
      }
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }

    get smooth() {
      if (this.dataset.ldSmooth === 'false') return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onClick(evt) {
      const button = evt.target.closest(SELECTORS.button);
      if (!button || button.disabled) return;

      // never navigate, never close the panel, never touch the URL
      evt.preventDefault();

      const letter = button.dataset.ldLetter;
      let top = 0;

      if (letter !== ALL) {
        const group = this.groups.filter(function (el) {
          return el.dataset.ldGroup === letter;
        })[0];
        if (!group) return;
        top =
          group.getBoundingClientRect().top -
          this.scroller.getBoundingClientRect().top +
          this.scroller.scrollTop -
          8;
      }

      this.scroller.scrollTo({
        top: Math.max(top, 0),
        left: 0,
        behavior: this.smooth ? 'smooth' : 'auto',
      });
      this.setActive(letter);
    }

    setActive(letter) {
      this.buttons.forEach(function (el) {
        const isActive = el.dataset.ldLetter === letter;
        el.classList.toggle(ACTIVE, isActive);
        if (isActive) {
          el.setAttribute('aria-current', 'true');
        } else {
          el.removeAttribute('aria-current');
        }
      });
    }

    onScroll() {
      if (this.panel && !this.panel.classList.contains('is-visible')) return;
      if (this.frame) return;
      this.frame = requestAnimationFrame(
        (function () {
          this.frame = null;
          this.syncActive();
        }).bind(this)
      );
    }

    syncActive() {
      const edge = this.scroller.getBoundingClientRect().top;
      let current = ALL;
      this.groups.forEach(function (el) {
        if (el.getBoundingClientRect().top - edge <= 24) {
          current = el.dataset.ldGroup;
        }
      });
      if (this.scroller.scrollTop <= 4) current = ALL;
      this.setActive(current);
    }
  }

  if (!customElements.get('alphabetical-directory')) {
    customElements.define('alphabetical-directory', Directory);
  }
})();
